import React, { useEffect, useState } from "react";
import { DropDown, RadioContainer } from "../commons";
import { CalenderIcon } from "../Icon";
import moment from "moment";
import DatePicker from "react-datepicker";
import {  Label } from "reactstrap";
import { RadioTypes } from "../../commonTypes/universalTypes";
import { FixedAssetRegisterForm } from "../../commonTypes/fixedAssetRegisterTypes";
import { RootState } from "../../redux/rootReducers";
import {
  getAllBusinessAddressAction,
  getDepartmentListAction,
  getSingleTypeLedgerListAction,
  resetBusinessAddressList,
  resetDepartmentList,
  resetSingleTypeLedgersList,
} from "../../redux/clientSettings";
import { connect } from "react-redux";
import {
  GetAllBussinessAddressesListPayloadType,
  GetAllLedgersListPayloadType,
  GetDepartmentListPayloadType,
} from "../../commonTypes/clientSettingsTypes";
import { handleDate, reverseDate } from "../../utils/commonFunctions";
import QRCode from "qrcode";
import {
  AllLedgersListType,
  DepartmentListType,
} from "../../redux/clientSettings/clientSettingTypes";
import ImageCombiner from "./FixedAssetTable/ImageCombiner";
import { BlobServiceClient } from "@azure/storage-blob";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { OptionProps, components } from "react-select";
import ProfileLoader from "../../screens/AllUsersAndClients/UserProfileEdit/ProfileLoader";

const Depreciation_Method_List = [
  {
    value: "Written-down Value",
    label: "Written-down Value",
  },
  {
    value: "Straight line",
    label: "Straight line",
  },
];

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "Missing",
    name: "Missing",
  },
  {
    id: "Good",
    name: "Good",
  },

  {
    id: "Bad",
    name: "Bad",
  },
  {
    id: "Obsolete",
    name: "Obsolete",
  },
  {
    id: "Yet to Capitalize",
    name: "Yet to Capitalize",
  },
];

type AppProps = {
  fixedAssetRegisterForm: FixedAssetRegisterForm;
  setFixedAssetRegisterForm: React.Dispatch<React.SetStateAction<any>>;
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  token: string | null;
  clientCode: number | null;
  loctionList: any | null;
  handleInputDetailsChange: (data: any) => void;
  singleFixedAsset: any;
  departmentList: DepartmentListType[] | [];
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) => void;
  allLedgersList: AllLedgersListType[] | [];
  dispatchResetSingleTypeLedgerListAction: () => void;
  dispatchResetBusinessAddressList: () => void;
  dispatchGetDepartmentList: (data: GetDepartmentListPayloadType) => void;
  dispatchResetDepartmentList: () => void;
  storeQRData: any;
  setStoreQRData: any;
  setSelectLoction: any;
  selectLoction: any;
  storeQRDataChanges: string;
};
const FixedAssetDeatils = ({
  fixedAssetRegisterForm,
  setFixedAssetRegisterForm,
  dispatchGetAllBusinessAddressAction,
  token,
  clientCode,
  loctionList,
  handleInputDetailsChange,
  singleFixedAsset,
  departmentList,
  dispatchGetAllLedgersListAction,
  allLedgersList,
  dispatchResetSingleTypeLedgerListAction,
  dispatchResetBusinessAddressList,
  dispatchResetDepartmentList,
  dispatchGetDepartmentList,
  storeQRData,
  setStoreQRData,
  selectLoction,
  setSelectLoction,
  storeQRDataChanges,
}: AppProps) => {
  const [selectCategory, setSelectCategory] = useState({
    label: Depreciation_Method_List[0]?.label,
    value: Depreciation_Method_List[0]?.value,
  });

  const [selectGeneral, setselectGeneral] = useState({
    label: "Select..",
    value: null,
  });

  const [selectDepartment, setSelectDepartment] = useState<any>({
    label: "Select",
    value: null,
  });

  const [generalListData, setGeneralListData] = useState([]);
  const [condition, setCondition] = useState(RADIO_OPTIONS[0].id);
  const [locationSearch, setLocationSearch] = useState("");
  const [locationListValue, setLocationValue] = useState<any>([]);
  const [departmentListValue, setDepartmentValue] = useState<any>([]);
  const [imageUrl, setImageUrl] = useState("");
  const [qrLoader, setQrLoader] = useState(false);

  const [logo, setLogo] = useState("");
  useEffect(() => {
    dispatchResetSingleTypeLedgerListAction();
    dispatchResetBusinessAddressList();
    dispatchResetDepartmentList();
    setDepartmentValue([]);
  }, []);

  useEffect(() => {
    if (token && clientCode) {
      let finalData: GetDepartmentListPayloadType = {
        token,
        client_code: clientCode,
      };
      dispatchGetDepartmentList(finalData);
    }
  }, []);

  useEffect(() => {
    if (token && clientCode) {
      let finalData = {
        client_code: clientCode,
        token,
        ledger_type: "assets",
      };

      dispatchGetAllLedgersListAction(finalData);
    }
  }, []);

  useEffect(() => {
    if (allLedgersList?.length) {
      let manipulateLedger = manipulateData(allLedgersList);
      if (manipulateLedger) {
        setGeneralListData(manipulateLedger);
      }
    }
  }, [allLedgersList]);

  useEffect(() => {
    if (loctionList?.length) {
      let newData = loctionList?.map((item: any) => {
        return {
          label: item?.trade_name,
          value: item?.ledger_id,
          logo: item?.logo_details,
        };
      });
      setLocationValue([...newData]);
    }
  }, [loctionList]);

  useEffect(() => {
    if (departmentList?.length) {
      let filterStatus = departmentList?.filter(
        (item: any) => item?.status === 1
      );

      let newData = filterStatus?.map((item: any) => {
        return {
          label: item?.department_name,
          value: item?.id,
        };
      });
      setDepartmentValue([...newData]);
    } else {
      setDepartmentValue([]);
    }
  }, [departmentList]);

  useEffect(() => {
    setSelectLoction((prv: any) => {
      return {
        label: singleFixedAsset?.location?.label
          ? singleFixedAsset?.location?.label
          : "Select",
        value: singleFixedAsset?.location?.value,
        logo: singleFixedAsset?.location?.logo?.file_url
          ? singleFixedAsset?.location?.logo?.file_url
          : "",
      };
    });
    if (singleFixedAsset?.location?.logo?.file_url) {
      setLogo(singleFixedAsset?.location?.logo?.file_url);
    }
    setStoreQRData({
      finac_asset_id: singleFixedAsset?.finac_asset_id,
      asset_id: singleFixedAsset?.asset_id,
      asset_description: singleFixedAsset?.asset_description,
      logo: singleFixedAsset?.location?.logo?.file_url
        ? singleFixedAsset?.location?.logo?.file_url
        : "",
      category: singleFixedAsset?.asset_category
        ? singleFixedAsset?.asset_category
        : "",
      departmentLabel: singleFixedAsset?.department
        ? singleFixedAsset?.department?.label
        : "",
      department: singleFixedAsset?.department
        ? singleFixedAsset?.department?.value
        : null,
      sub_location: singleFixedAsset?.sub_location
        ? singleFixedAsset?.sub_location
        : "",
      gl_code: singleFixedAsset?.gl_code ? singleFixedAsset?.gl_code : "",
    });

    setSelectDepartment((prv: any) => {
      return {
        label: singleFixedAsset?.department?.label
          ? singleFixedAsset?.department?.label
          : "Select",
        value: singleFixedAsset?.department?.value,
      };
    });

    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        qr_code: singleFixedAsset?.qr_code,
      };
    });
    if (singleFixedAsset?.qr_code) {
      setImageUrl(singleFixedAsset?.qr_code);
    } else {
      setImageUrl("");
    }
    if (singleFixedAsset?.general_ledger?.value) {
      setselectGeneral(() => {
        return {
          label: singleFixedAsset?.general_ledger?.label,
          value: singleFixedAsset?.general_ledger?.value,
        };
      });
    } else {
      setselectGeneral(() => {
        return {
          label: "Select..",
          value: null,
        };
      });
    }
    if (singleFixedAsset?.condition) {
      setCondition(singleFixedAsset?.condition);
    } else {
      setCondition(RADIO_OPTIONS[0].id);
    }
  }, [singleFixedAsset]);

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName = `clientcontainer${clientCode}`;
  const containerClient = blobServiceClient.getContainerClient(containerName);

  const uploadFiles = async (uploadedFile: any) => {
    try {
      let resp;
      const blockBlobClient = containerClient.getBlockBlobClient(
        new Date().valueOf() +
          "." +
          uploadedFile.name.split(".")[uploadedFile.name.split(".").length - 1]
      );
      resp = await blockBlobClient.uploadBrowserData(uploadedFile);
      if (
        resp &&
        resp["_response"] &&
        resp["_response"].status &&
        resp["_response"].status === (201 || 200)
      ) {
        updateDocumentAPI(
          uploadedFile.name,
          blockBlobClient["_name"],
          blockBlobClient["_containerName"],
          uploadedFile.type
        );
      } else {
        alert("something wrong");
      }
    } catch (error) {}
  };

  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: any = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };
    setQrLoader(false);
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        qr_code: data?.file_url,
      };
    });
    setLogo(selectLoction?.logo);
    setImageUrl(data?.file_url);
  };

  useEffect(() => {
    if (singleFixedAsset?.depreciation_method) {
      setSelectCategory((prv: any) => {
        return {
          label: singleFixedAsset?.depreciation_method,
          value: singleFixedAsset?.depreciation_method,
        };
      });
    } else {
      setSelectCategory((prv: any) => {
        return {
          label: Depreciation_Method_List[0]?.label,
          value: Depreciation_Method_List[0]?.value,
        };
      });
    }
  }, [singleFixedAsset]);

  useEffect(() => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        condition,
      };
    });
  }, [condition]);

  useEffect(() => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        location: selectLoction.value,
      };
    });
  }, [selectLoction]);

  useEffect(() => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        general_ledger: selectGeneral.value,
      };
    });
  }, [selectGeneral]);

  const handleMethodChange = (e: any) => {
    setSelectCategory({
      label: e.label,
      value: e.value,
    });
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        depreciation_method: e.value,
      };
    });
  };

  const handleChangeCondition = (value: string) => {
    setCondition(value);
  };

  const handleLoctionChange = (e: any) => {
    // setImageUrl("");
    setSelectLoction({
      label: e.label,
      value: e.value,
      logo: e?.logo?.file_url,
    });
  };
  const handleDepartmentChange = (e: any) => {
    setSelectDepartment({
      label: e.label,
      value: e.value,
    });
  };

  // useEffect(() => {
  //   setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
  //     return {
  //       ...prv,
  //       location: selectLoction.value,
  //     };
  //   });
  // }, [selectLoction]);

  useEffect(() => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        department: selectDepartment.value,
      };
    });
  }, [selectDepartment]);

  useEffect(() => {
    if (token && clientCode && token) {
      let finatData = {
        token,
        search_term: locationSearch,
        client_code: clientCode,
      };
      dispatchGetAllBusinessAddressAction(finatData);
    }
  }, [locationSearch]);

  const generate = async () => {
    let routeValidation = window.location.href;
    try {
      setQrLoader(true);
      const response = await QRCode.toDataURL(
        `${
          routeValidation?.includes("http://localhost")
            ? `https://admin.akssai.com/fixed-asset-register/${clientCode}/physical-verification/${fixedAssetRegisterForm?.finac_asset_id}`
            : routeValidation?.includes("https://admin")
            ? `https://admin.akssai.com/fixed-asset-register/${clientCode}/physical-verification/${fixedAssetRegisterForm?.finac_asset_id}`
            : routeValidation?.includes("https://finac")
            ? `https://finac.akssai.com/fixed-asset-register/${clientCode}/physical-verification/${fixedAssetRegisterForm?.finac_asset_id}`
            : ""
        }`
      );

      setStoreQRData({
        finac_asset_id: fixedAssetRegisterForm?.finac_asset_id,
        asset_id: fixedAssetRegisterForm?.asset_id,
        asset_description: fixedAssetRegisterForm?.asset_description,
        logo: selectLoction?.logo,
        sub_location: fixedAssetRegisterForm?.sub_location,
        departmentLabel: fixedAssetRegisterForm?.department
          ? selectDepartment?.label
          : "",
        department: fixedAssetRegisterForm?.department
          ? selectDepartment?.value
          : null,
        category: fixedAssetRegisterForm?.asset_category,
        gl_code: fixedAssetRegisterForm?.gl_code,
      });

      const dataURLtoFile = (dataurl: any, filename: any) => {
        if (dataurl) {
          var arr = dataurl?.split(","),
            mime = arr[0]?.match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr?.length,
            u8arr = new Uint8Array(n);

          while (n--) {
            u8arr[n] = bstr?.charCodeAt(n);
          }
          return new File([u8arr], filename, { type: mime });
        }
      };

      var file1 = dataURLtoFile(response, "image.jpg");
      uploadFiles(file1);
    } catch (error) {}
  };

  ///////////////////////////account manager
  const manipulateData = (data: any) => {
    let finalData: any = [];
    data?.map((tempData: any) => {
      finalData.push({
        level: 1,
        ledger_number: tempData?.ledger_number,
        label: tempData?.ledger_name,
        ledger_tech_type: tempData?.ledger_type,
        value: tempData?.ledger_id,
        parentAccount: "",
        updated_at: tempData?.updated_at,
        parent_id: tempData?.parent_id,
        to_show: tempData?.to_show,
        cog_type: tempData?.cog_type,
        is_tree: tempData?.is_tree,
        isDisabled: tempData?.to_show == 0 ? true : false,
      });
      if (tempData?.is_tree) {
        tempData?.tree_data?.map((tree: any) => {
          finalData.push({
            level: 2,
            ledger_number: tree?.ledger_number,
            label: tree?.ledger_name,
            ledger_tech_type: tree?.ledger_type,
            value: tree?.ledger_id,
            parentAccount: tempData?.ledger_name,
            updated_at: tree?.updated_at,
            parent_id: tree?.parent_id,
            to_show: tree?.to_show,
            cog_type: tree?.cog_type,
            is_tree: tempData?.is_tree,
            isDisabled: tree?.to_show == 0 ? true : false,
          });
          if (tree?.is_tree) {
            tree?.tree_data?.map((treeD: any) => {
              finalData.push({
                level: 3,
                ledger_number: treeD?.ledger_number,
                label: treeD?.ledger_name,
                ledger_tech_type: treeD?.ledger_type,
                value: treeD?.ledger_id,
                parentAccount: tree?.ledger_name,
                updated_at: treeD?.updated_at,
                parent_id: treeD?.parent_id,
                to_show: treeD?.to_show,
                cog_type: treeD?.cog_type,
                is_tree: tempData?.is_tree,
                isDisabled: treeD?.to_show == 0 ? true : false,
              });
              if (treeD?.is_tree) {
                treeD?.tree_data?.map((treeD1: any) => {
                  finalData.push({
                    level: 4,
                    ledger_number: treeD1?.ledger_number,
                    label: treeD1?.ledger_name,

                    ledger_tech_type: treeD1?.ledger_type,
                    value: treeD1?.ledger_id,
                    parentAccount: treeD?.ledger_name,
                    updated_at: treeD1?.updated_at,
                    parent_id: treeD1?.parent_id,
                    to_show: treeD1?.to_show,
                    cog_type: treeD1?.cog_type,
                    is_tree: tempData?.is_tree,
                    isDisabled: treeD1?.to_show == 0 ? true : false,
                  });
                });
              }
            });
          }
        });
      }
    });

    return finalData;
  };

  const Option = (props: OptionProps<AllLedgersListType, false>) => {
    return (
      <components.Option {...props}>
        <ul
          className={`ledger-list ${
            props.data.level === 1
              ? "ledger-list-first"
              : props.data.level === 2
              ? "ledger-list-second"
              : props.data.level === 3
              ? "ledger-list-third"
              : "ledger-list-fourth"
          }`}
        >
          <li>{props.children}</li>
        </ul>
      </components.Option>
    );
  };

  const handleChangeGeneralLedger = (e: any) => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        general_ledger: e.value,
      };
    });
    setselectGeneral(() => {
      return {
        label: e.label,
        value: e.value,
      };
    });
  };
  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">
              Finac Asset ID <span className="color-red">*</span>
            </label>
            <div>
              <input
                name="title"
                type="text"
                className={`form-control`}
                disabled
                value={
                  fixedAssetRegisterForm?.finac_asset_id
                    ? fixedAssetRegisterForm?.finac_asset_id
                    : ""
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">
              Asset ID <span className="color-red">*</span>
            </label>
            <div>
              <input
                name="asset_id"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.asset_id}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="clientName"></label>

            <div style={{ display: "flex", position: "relative" }}>
              <button
                style={{
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  fontSize: "13px",
                }}
                className="btn btn-outline-secondary"
                disabled={
                  !fixedAssetRegisterForm?.asset_id ||
                  !fixedAssetRegisterForm?.finac_asset_id ||
                  !fixedAssetRegisterForm?.asset_description
                }
                onClick={generate}
              >
                Generate QR Code
              </button>

              {qrLoader ? (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    position: "absolute",
                    left: "160px",
                  }}
                >
                  <ProfileLoader />
                </div>
              ) : (
                <>
                  {imageUrl && fixedAssetRegisterForm?.finac_asset_id && (
                    <>
                      <ImageCombiner
                        qrcodeImage={`${blobBaseUrl}${imageUrl}?${blobToken}`}
                        logoSrc={
                          logo ? `${blobBaseUrl}${logo}?${blobToken}` : ""
                        }
                        appendedText={fixedAssetRegisterForm?.finac_asset_id}
                        category={storeQRData?.category}
                        description={storeQRData?.asset_description}
                        assetId={storeQRData?.asset_id}
                        subLocation={storeQRData?.sub_location}
                        department={storeQRData?.departmentLabel}
                        glCode={storeQRData?.gl_code}
                      />
                    </>
                  )}
                </>
              )}
              <div
                style={{
                  position: "absolute",
                  left: "120px",
                  top: "120px",
                  color: "orange",
                }}
              >
                {storeQRDataChanges}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Department</label>
            <div>
              <DropDown
                options={departmentListValue}
                value={selectDepartment}
                handleChange={handleDepartmentChange}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">
              Location <span className="color-red">*</span>
            </label>
            <div>
              <DropDown
                options={locationListValue}
                value={selectLoction}
                handleChange={handleLoctionChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="clientName">
              Asset Description <span className="color-red">*</span>
            </label>
            <div>
              <textarea
                name="asset_description"
                className={`form-control`}
                value={fixedAssetRegisterForm?.asset_description}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Asset Category</label>
            <div>
              <input
                name="asset_category"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.asset_category}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">
              Asset Sub-Category <span className="color-red"></span>
            </label>
            <div>
              <input
                name="asset_sub_category"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.asset_sub_category}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Depreciation Method</label>
            <div>
              <DropDown
                options={Depreciation_Method_List}
                value={selectCategory}
                handleChange={handleMethodChange}
              />
            </div>
          </div>
        </div>
      </div>
      {/* /////   third row */}
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Date of put to use</label>
            <div>
              <div>
                <div className="d-flex flex-row position-relative">
                  <div className="date-picker-wraper mr-0 w-100">
                    <Label className="mr-0 w-100">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={
                          fixedAssetRegisterForm?.date_of_put_to_use
                            ? new Date(
                                moment(
                                  `${reverseDate(
                                    fixedAssetRegisterForm?.date_of_put_to_use
                                  )}T00:00:00`,
                                  "YYYY-MM-DD"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        onChange={(e: any) => {
                          let datePut = handleDate(
                            moment(e).format("YYYY-MM-DD")
                          );
                          setFixedAssetRegisterForm({
                            ...fixedAssetRegisterForm,
                            date_of_put_to_use: datePut?.length
                              ? reverseDate(datePut)
                              : null,
                          });
                        }}
                        fixedHeight
                        showMonthDropdown
                        showYearDropdown
                        name="date_put"
                        placeholderText="Select"
                        className="form-control"
                      />
                      <span
                        className="calender-icon"
                        style={{
                          right: "20px",
                          top: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">General Ledger(GL)</label>
            <div>
              <Select<any, false>
                inputProps={{ autoComplete: "nope" }}
                placeholder={"Select..."}
                options={generalListData}
                value={selectGeneral}
                className={`react-select`}
                classNamePrefix="react-select"
                components={{ Option }}
                onChange={handleChangeGeneralLedger}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">GL Code</label>
            <div>
              <input
                name="gl_code"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.gl_code}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Manufacturer</label>
            <div>
              <input
                name="manufacturer"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.manufacturer}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Sub-Location</label>
            <div>
              <input
                name="sub_location"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.sub_location}
                onChange={(e) => {
                  handleInputDetailsChange(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2 mb-4">
        <label htmlFor="clientName">Condition</label>
        <div className="mt-2 ">
          <RadioContainer
            optionsList={RADIO_OPTIONS}
            handleSetRadioValue={handleChangeCondition}
            radioValue={condition}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loctionList: state.clientSettings.businessAddressList,
  departmentList: state.clientSettings.departmentList,
  allLedgersList: state.clientSettings.singleTypeLedgerList,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllBusinessAddressAction: (data: any) =>
    dispatch(getAllBusinessAddressAction(data)),
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getSingleTypeLedgerListAction(data)),
  dispatchResetSingleTypeLedgerListAction: () =>
    dispatch(resetSingleTypeLedgersList()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
  dispatchGetDepartmentList: (data: GetDepartmentListPayloadType) => {
    dispatch(getDepartmentListAction(data));
  },
  dispatchResetDepartmentList: () => dispatch(resetDepartmentList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(FixedAssetDeatils);
